import { defineComponent as _defineComponent } from 'vue'
import { Box } from '@/ui/components/Box';
  import YoutubeIframe from '@/ui/components/common/YoutubeIframe.vue';
  import { Button } from '@/ui/components/Button';
  import { AI_PHOTO_VALIDATION_DEMO_VIDEO_ID } from './constants';
  import { getWebsiteContactUrl } from '@/ui/helpers/websiteHelper';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiPhotoValidationEmptyState',
  setup(__props) {

  const handleContactUs = () => {
    window.open(getWebsiteContactUrl(), '_blank');
  };

return { __sfc: true,handleContactUs, Box, YoutubeIframe, Button, AI_PHOTO_VALIDATION_DEMO_VIDEO_ID }
}

})